import { useWorkoutCardContext } from './workout-card'
import React from 'react'
import { Badge } from 'src/component/ui/badge/badge'

export const WorkoutCardDuration = (): React.ReactElement | null => {
  const { workout } = useWorkoutCardContext()

  if (!workout.duration) {
    return null
  }

  return (
    <div className="self-start">
      <Badge>{workout.duration} min</Badge>
    </div>
  )
}
